<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      :class="{ show: show }"
      class="close-chat-modal"
      :style="{
        'background-color': getWebchat().campaign.color,
        color: invertColor(getWebchat().campaign.color),
      }"
    >
      <v-row no-gutters class="pt-2">
        <v-col cols="12"
          ><span style="font-size: clamp(8px, 3.4vw, 16px)">{{
            messageDialogue
          }}</span></v-col
        >
        <v-col cols="12">
          <v-btn
            text
            @click.native="confirmClosing"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
            >{{ $t("yes") }}</v-btn
          >
          <v-btn
            text
            @click.native="cancelClosing"
            :style="{
              color: invertColor(getWebchat().campaign.color),
            }"
          >
            {{ $t("no") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { invertColor } from "@/assets/utils";
export default {
  props: { show: Boolean, messageDialogue: String },
  name: "closing-dialog",
  data() {
    return {
      dialog: false,
      window: window,
    };
  },

  methods: {
    invertColor,

    cancelClosing() {
      this.$emit("cancelClosingEv", false);
    },

    confirmClosing() {
      this.$emit("confirmClosingEv", true);
    },

    getWebchat() {
      return this.$store.state[
        this.$store.state.findIndex(
          (e) => e.configuration.campaign === this.$route.query.campaign
        )
      ];
    },
  },
};
</script>

<style>
.close-chat-modal {
  top: 0px;
  height: 75px;
  opacity: 0;
  padding-top: 10px;
  border-top: 1px solid #00000054;
  box-shadow: 0px 4px 5px -3px #00000066;
  text-align: center;
  transition: all 0.3s ease-out;
  background: linear-gradient(
    129deg,
    rgba(35, 146, 236, 0),
    rgba(0, 0, 0, 0.35)
  );
}

.close-chat-modal.show {
  top: 67px;
  opacity: 1;
  z-index: 999999;
}

.close-chat-modal button {
  z-index: 2;
  opacity: 0.8;
}
</style>
